import React from 'react';
import { Button } from '../../Buttons';
import { ErrorFooterStyled, ErrorTemplateStyled, ErrorViewImage, ErrorViewInner, Heading, TextContainer } from './ErrorTemplate.styles';
export function ErrorFooter(_ref) {
  let {
    onClick,
    label,
    children
  } = _ref;
  return label || children ? /*#__PURE__*/React.createElement(ErrorFooterStyled, null, onClick && /*#__PURE__*/React.createElement(Button, {
    onClick: onClick
  }, " ", label, " "), children) : null;
}
export function ErrorTemplate(props) {
  const imageAltText = props.imageAltText ? props.imageAltText : 'photo depicting an error';
  const iconSize = props.level === 'tile' ? 'small' : 'medium';
  return /*#__PURE__*/React.createElement(ErrorTemplateStyled, null, /*#__PURE__*/React.createElement(ErrorViewInner, null, /*#__PURE__*/React.createElement(ErrorViewImage, {
    src: props.image,
    alt: imageAltText,
    size: iconSize
  }), /*#__PURE__*/React.createElement(TextContainer, null, /*#__PURE__*/React.createElement(Heading, null, props.heading), props.children)));
}